import axios from 'axios';
import * as api from './constants';

export function updateFilteredDate(query) {
  return axios
    .get(api.UPDATE_FILTERED_DATE, { params: query, withCredentials: true })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}
